import { render } from "./LegalView.vue?vue&type=template&id=47c24824"
import script from "./LegalView.vue?vue&type=script&lang=js"
export * from "./LegalView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/florianroscher/Sites/simtschuk-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__